export enum PaymentMethodEnum {
  creditCard,
  bankSlip,
}
